import ondcPolicyData from "./ondcPolicyData"
import privacyData from "./privacyData"
import refundData from "./refundData"
import returnsData from "./returnsData"
import shippingData from "./shippingData"
import termsData from "./termsData"

export const policies = [
  {
    policyName: 'PRIVACY',
    title: 'Privacy Policy',
    lastUpdated: '18th Sep 2024',
    email: 'contact@mindsclik.com',
    list: [ "Business Consulting",
            "Business Process Analysis",
            "End 2 End Process Consulting",
            "Enhance Shoppable Experience",
            "Digital Content and Marketing"
          ]
  },
]

export const policyMap = {
  privacy: privacyData,
  terms: termsData,
  shipping: shippingData,
  returns: returnsData,
  refund: refundData,
  ondc_seller_app: ondcPolicyData

}